<template lang='html'>
<v-tab-item :id="name">
  <v-layout row wrap class="pa-0" v-if="!vip_info.mobile">
      <v-flex xs12 sm12 md12 xl12 lg12>
        <v-layout row wrap class="pa-0">
          <v-flex xs9 >
            <v-text-field v-model="gid"  label="商品过滤" clearable ></v-text-field>
          </v-flex>
          
          <v-flex xs3 >
            <v-btn  color="success" @click="lookup_home_stock()">
              <v-icon dark class="iconfont">icon-search</v-icon>
              <span> 查询仓库库存 </span>
            </v-btn>
            <v-btn color="primary" @click="next_page()" v-if="total_pages>1">
              <v-icon dark class="iconfont" >ti-angle-right</v-icon>
              <span>下一页({{curr_page}}/{{total_pages}})</span>
            </v-btn>
          </v-flex>
        </v-layout>
      </v-flex>
  </v-layout>

  <v-flex xl12 lg12 md12 xs12>
    <!-- {{list_array}} {{prepare_list}} -->
      <div class="app-card mb-0">
          <div class="app-card-content">
            <ul class="ace-thumbnails clearfix">
              <li v-for="item in list_array" @click = "sale_it(item)">
                <a href = "#"class = "cboxElement">
                  <!-- <img  v-lazy= "img_url(item)" />  -->
                   <img  :src = "img_url(item)" @error="default_img(item)"/> 
                  <div class = "text" > 
                    <div class = "inner" v-if="item.nm"   v-text = "item.nm" > </div>
                    <div class = "inner" v-if="item.name" v-text = "item.name" > </div>
                  </div > 
                </a> 
                <div class="tags"> 
                  <span class="label-holder"> 
                    <span class="label label-danger red--text" v-if="item.save_num" style="font-size: 25px;">存:{{item.save_num}}</span > 
                  </span> 
                  <span class="label-holder"> 
                    <span class="label label-purple" v-if="item.count" v-text="item.count"></span > 
                  </span> 
                  <span class="label-holder"> 
                    <span class="label label-name black--text" v-if="item.nm" v-text="item.nm"></span > 
                    <span class="label label-name black--text" v-if="item.name" v-text="item.name"></span > 
                  </span>
                  <span class="label-holder"> 
                    <span class="label label-name black--text" v-text="item.gid"></span > 
                  </span> 
                </div >
              </li>
            </ul>
          </div>
      </div>
  </v-flex>   
</v-tab-item>


    
</template>

<script>
/* eslint-disable */  
import { mapGetters,mapMutations } from 'vuex'

export default {
    //template:``,
    name: '',
    props:{
      name:{type:String,default:'tab-prepare'},
      count_per:{type:Number,default:50}
    },
    computed:{
      ...mapGetters({
        vip_info      :'vip_info',
        prepare_list   :'get_prepare_list',
        // list       :'get_prodcuts_list',//商品列表
        // item_money :'get_product_money',//单品总金额
        // item_discount:'get_product_discount',//单品折扣
      }),
      isfinished: function() {
          return this.$store.getters.get_pay_info.pay_status
      },
      total_pages:function(){
          let self = this;
          if(!self.prepare_list) return 0;
          return Math.ceil((self.prepare_list.length)/self.count_per);
      },
      list_array:function(){
          let self = this;

          return self.prepare_list.filter((it,index)=>{
             let name = it.name?it.name:it.nm?it.nm:"";

             if(self.gid ){
                  let upGid = self.gid.toUpperCase();
                  if(it.gid.includes(self.gid)) return true;
                  if(name.includes(self.gid)) return true;
                  if(it.zhujima && it.zhujima.includes(upGid)) return true;
             }else if(index >= self.curr_page * self.count_per && 
                      index < (self.curr_page+1) * self.count_per)
                return true;
             return false;
          })
      }
    },
    methods:{
      lookup_home_stock(){
        let self = this;
        self.$store.dispatch('act_lookup_home_stock',{ 
              gid:"",name:"",
              prepare:false,
              self,
              callback :(data,tab='tab-prepare')=>{
                self.$store.commit("SHOW_DIALOG_ACTIVE_TAB",tab);
              }
          })
      },
      next_page(){
          if(this.total_pages ==0)  return this.curr_page = 0;
          this.curr_page += 1;
          this.curr_page %= this.total_pages;
      },
      msgpad_show(group,title,text,type){
        this.$notify({ group, title, text, type})
      },
      img_url(item){
        if(item.def) return "http://www.fa-xiao.com/icons/none.png";
        return "http://www.fa-xiao.com/icons/"+item.gid+".jpg"
      },
      default_img(item){
        // item.def= true;
        this.$set(item,'def',true)
        // debugger
        console.log("Load IMG ERROR:",item.gid)
      },
      sale_it( item){
        if(this.isfinished > 0){
          return this.msgpad_show("msgpad", "", "本单已经结算", 'error');
        }
        let obj = Object.assign({},item);
        obj.oper = 'add';
        // debugger
        if(obj.save_num > 0){
            obj.sale_price = 0;
            obj.vip_price  = {};
            obj.real_price = obj.real_vip_price = obj.sale_price = 0.0;
            obj.save_take  = "take";
            obj.all_num    = obj.save_num;
            obj.save_num   = 0;
        }else{
            obj.save_take = 'sale';
            if(obj.shop_id){//仓库库存
                obj.sale_price = 0;
                obj.vip_price  = {};
                obj.real_price = obj.real_vip_price = obj.sale_price = 0.0;
            }
        }
        obj.num  = 1;
        obj.name = obj.nm||obj.name;
        obj.vip = this.$store.getters.vip_info.user_group;
        // debugger
        // this.$store.commit('ACTIVE_SALE_TAB_SHEET',true);
        this.$store.commit('PRODUCTS_EDIT_ITEM',obj);
        this.$emit("active_tab",'tab-sale');
        this.$emit('clear_input');
        console.log("sale_it",this.$root,"CLEAR_INPUT");

      }
    },
    components:{},
    watch:{},
    directives: {},
    mounted :function(){},
    data () {
      return {
          gid:'',
          curr_page:0,
      }
    },
    filters: {
      //pluralize: (n, w) => n === 1 ? w : (w + 's'),
      capitalize: s => s.charAt(0).toUpperCase() + s.slice(1)
    }
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.label-name{
  font-size: 1.1em !important;
}
.ace-thumbnails {
  list-style : none;
  margin     : 0;
  padding    : 0;
}
.ace-thumbnails > li {
  float    : left;
  display  : block;
  position : relative;
  overflow : hidden;
  margin   : 2px;
  width    : 150px;
  height   : 150px;
  border   : 2px solid #333;
}
.ace-thumbnails > li > :first-child {
  display: block;
  position: relative;
}
.ace-thumbnails > li > :first-child:focus {
  outline: none;
}
.ace-thumbnails > li .tags {
  display: inline-block;
  position: absolute;
  bottom: 0;
  right: 0;
  overflow: visible;
  direction: rtl;
  padding: 0;
  margin: 0;
  height: auto;
  width: auto;
  background-color: transparent;
  border-width: 0;
  vertical-align: inherit;
}
.ace-thumbnails > li .tags > .label-holder {
  opacity: 0.82;
  filter: alpha(opacity=92);
  display: table;
  margin: 1px 0 0 0;
  direction: ltr;
  text-align: left;
}
.ace-thumbnails > li .tags > .label-holder:hover {
  opacity: 1;
  filter: alpha(opacity=100);
}
.ace-thumbnails > li > .tools {
  position: absolute;
  top: 0;
  bottom: 0;
  left: -30px;
  width: 24px;
  background-color: rgba(0, 0, 0, 0.55);
  text-align: center;
  vertical-align: middle;
  -webkit-transition: all 0.2s ease;
  -o-transition: all 0.2s ease;
  transition: all 0.2s ease;
}
.ace-thumbnails > li > .tools.tools-right {
  left: auto;
  right: -30px;
}
.ace-thumbnails > li > .tools.tools-bottom {
  width: auto;
  height: 28px;
  left: 0;
  right: 0;
  top: auto;
  bottom: -30px;
}
.ace-thumbnails > li > .tools.tools-top {
  width: auto;
  height: 28px;
  left: 0;
  right: 0;
  top: -30px;
  bottom: auto;
}
.ace-thumbnails > li:hover > .tools {
  left: 0;
  right: 0;
}
.ace-thumbnails > li:hover > .tools.tools-bottom {
  top: auto;
  bottom: 0;
}
.ace-thumbnails > li:hover > .tools.tools-top {
  bottom: auto;
  top: 0;
}
.ace-thumbnails > li:hover > .tools.tools-right {
  left: auto;
  right: 0;
}
.ace-thumbnails > li > .in.tools {
  left: 0;
  right: 0;
}
.ace-thumbnails > li > .in.tools.tools-bottom {
  top: auto;
  bottom: 0;
}
.ace-thumbnails > li > .in.tools.tools-top {
  bottom: auto;
  top: 0;
}
.ace-thumbnails > li > .in.tools.tools-right {
  left: auto;
  right: 0;
}
.ace-thumbnails > li > .tools > a,
a > img{
  top:0;
  bottom:0;
  left:0;
  right:0;
  max-width: 100%;
    max-height: 100%;
}
.ace-thumbnails > li > :first-child .inner a {
  display: inline-block;
  color: #FFF;
  font-size: 18px;
  font-weight: normal;
  padding: 0 4px;
}
.ace-thumbnails > li > .tools > a:hover,
.ace-thumbnails > li > :first-child .inner a:hover {
  text-decoration: none;
  color: #C9E2EA;
}
.ace-thumbnails > li .tools.tools-bottom > a,
.ace-thumbnails > li .tools.tools-top > a {
  display: inline-block;
}
.ace-thumbnails > li > :first-child > .text {
  position: absolute;
  right: 0;
  left: 0;
  bottom: 0;
  top: 0;
  text-align: center;
  color: #FFF;
  background-color: rgba(0, 0, 0, 0.55);
  opacity: 0;
  filter: alpha(opacity=0);
  -webkit-transition: all 0.2s ease;
  -o-transition: all 0.2s ease;
  transition: all 0.2s ease;
}
.ace-thumbnails > li > :first-child > .text:before {
  /* makes the inner text become vertically centered*/
  content: '';
  display: inline-block;
  height: 100%;
  vertical-align: middle;
  margin-right: 0;
  /* Adjusts for spacing */
}
.ace-thumbnails > li > :first-child > .text > .inner {
  padding: 4px 0;
  margin: 0;
  display: inline-block;
  vertical-align: middle;
  max-width: 90%;
}
.ace-thumbnails > li:hover > :first-child > .text {
  opacity: 1;
  filter: alpha(opacity=100);
}

.label {
    font-size: 12px;
    line-height: 1.15;
    height: 20px;
    border-radius: 0;
    text-shadow: none;
    font-weight: normal;
    color: #ffffff;
    display: inline-block;
}

.label-warning, .label.label-warning {
  background-color: #f89406;
}

</style>



<!-- Add "scoped" attribute to limit CSS to this component only -->



// WEBPACK FOOTER //
// src/views/front_sale/components/prepare.vue